import { Link } from "react-router-dom";
import { resourceSites } from "@/mocks/resources";
import SectionHeading from "@/components/feature/SectionHeading";

export default function ResourcePreview() {
  const sites = resourceSites.slice(0, 4);
  return (
    <section className="bg-background-100 border-y border-background-200/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex items-end justify-between gap-4 flex-wrap">
          <SectionHeading
            eyebrow="RESOURCES"
            title="靠谱资源站精选"
            desc="从海量韩国免费漫画网站中筛选出的稳定入口，覆盖日更、高清无遮拦等不同需求。"
          />
          <Link
            to="/ziyuan"
            className="mb-8 md:mb-10 inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            全部资源站 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {sites.map((s) => (
            <div
              key={s.id}
              className="rounded-xl bg-background-200/60 border border-background-300/50 p-5 hover:border-primary-400/60 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100/70 text-secondary-500 font-bold">
                  {s.category}
                </span>
                <span className="text-accent-500 text-xs font-bold">{s.stability}</span>
              </div>
              <h3 className="mt-3 font-heading text-base text-foreground-950">{s.name}</h3>
              <p className="mt-1 text-xs text-foreground-600">{s.tagline}</p>
              <p className="mt-3 text-xs text-foreground-500 leading-relaxed">{s.features.join(" · ")}</p>
              <div className="mt-3 flex items-center justify-between text-[11px] text-foreground-600">
                <span>{s.update}</span>
                <span>{s.works} 作品</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}